module.exports = __webpack_public_path__ + "img/burger.36ed7b63.svg";